var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "264", height: "264", viewBox: "0 0 264 264", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "mask",
      { id: "id-61a", style: {
          maskType: "alpha"
        }, maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "264", height: "264" },
      React.createElement("circle", { cx: "132", cy: "132", r: "131.5", fill: "#FAFAFA", stroke: "#000" })
    ),
    React.createElement(
      "g",
      { mask: "url(#id-61a)" },
      React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M132 166.191C165.209 166.191 192.131 139.285 192.131 106.095C192.131 72.9056 165.209 46 132 46C98.7907 46 71.8693 72.9056 71.8693 106.095C71.8693 139.285 98.7907 166.191 132 166.191ZM98.7473 180.464C53.5995 180.464 17 217.063 17 262.211C17 263.114 17.732 263.846 18.6349 263.846H245.365C246.268 263.846 247 263.114 247 262.211C247 217.063 210.4 180.464 165.253 180.464H98.7473Z", fill: "#ECECEC" })
    )
  );
});